import { getBreakpoints } from '../base/common';

(function ($) {
  function getPictureHeight(container) {
    const picture = container.find('.content-box__picture, .featured-offer__slider');
    const pictureHeight = picture.height();
    return pictureHeight;
  }

  function getExpanderHeight(container) {
    const expander = container.find('.c-expander__button');
    const expanderHeight = expander.outerHeight(true);
    return expanderHeight;
  }

  function getMoreLinksHeight(container) {
    const moreLinks = container.find('.content-box__more-wrapper');
    const moreLinksHeight = moreLinks.outerHeight(true);
    return moreLinksHeight;
  }

  function getReferenceHeight(container) {
    const reference = container.find('.content-box__reference');
    const referenceHeight = reference.outerHeight(true);
    return referenceHeight;
  }

  function getButtonHeight(container) {
    const button = container.find('.content-box__button, .featured-offer__button');
    const buttonHeight = button.outerHeight(true);
    return buttonHeight;
  }

  function getAdditionalHeight(container) {
    const pictureHeight = getPictureHeight(container);
    const expanderHeight = getExpanderHeight(container);
    const moreLinksHeight = getMoreLinksHeight(container);
    const referenceHeight = getReferenceHeight(container);
    const buttonHeight = getButtonHeight(container);
    const additionalHeight = pictureHeight - ((expanderHeight !== undefined ? expanderHeight : 0)
      + (moreLinksHeight !== undefined ? moreLinksHeight : 0)
      + (referenceHeight !== undefined ? referenceHeight : 0)
      + (buttonHeight !== undefined ? buttonHeight : 0));
    return additionalHeight;
  }

  function hideExpander(expander) {
    expander.find('.c-expander__shadow').hide();
    expander.find('.c-expander__button').hide();
    expander.find('.c-expander__excerpt').height('auto');
  }

  function refreshTabindex() {
    const $container = $('.c-expander__excerpt-inner a');
    $container.overflowing('.c-expander__excerpt', (overflowed) => {
      if (overflowed instanceof $) {
        overflowed.find('a').each(function () {
          const excerptWrapper = $(this).closest('.c-expander__excerpt');
          if (excerptWrapper.length) {
            if ($(this).offset().top > excerptWrapper.offset().top + excerptWrapper.height()) {
              $(this).attr('tabindex', -1);
            }
          }
        });
      }
    });
  }

  function toggleExpander(element) {
    const curContentBoxContainer = $(element).closest('.content-box');
    const curExpanderContainer = $(element).closest('.c-expander');
    const curContainer = curContentBoxContainer.length ? curContentBoxContainer
      : curExpanderContainer;

    const container = $(element).closest('.content-box__container, .featured-offer');

    const curShadow = curContainer.find('.c-expander__shadow');
    const curExcerpt = curContainer.find('.c-expander__excerpt');
    const curDetails = curContainer.find('.content-box-details');
    const curButtonLabel = curContainer.find('.c-expander__button-label');

    curShadow.toggleClass('expanded');
    curExcerpt.toggleClass('expanded');
    curButtonLabel.toggleClass('expanded');

    if (curExcerpt.hasClass('expanded')) {
      curExcerpt.find('a').attr('tabindex', 0);
      curExcerpt.height('auto');
    } else {
      const additionalHeight = getAdditionalHeight(container);
      curExcerpt.height(additionalHeight);
      refreshTabindex();
    }

    if (curDetails.length) {
      curDetails.toggleClass('content-box-details__expanded').find('.c-expander__button-label.expanded').focus();
      curButtonLabel.toggleClass('expanded d-none');
    }
  }

  function showButton() {
    const $expander = $('.c-expander');

    $expander.each(function () {
      const curExpander = $(this);
      const container = curExpander.closest('.content-box__container, .featured-offer');
      const pictureHeight = getPictureHeight(container);
      const offerInner = container.find('.featured-offer__inner');
      const curShadow = curExpander.find('.c-expander__shadow');
      const curButton = curExpander.find('.c-expander__button');
      const curExcerpt = curExpander.find('.c-expander__excerpt');
      const buttonLabel = curExpander.find('.c-expander__button-label');

      hideExpander(curExpander);

      if (curExcerpt.hasClass('expanded') && buttonLabel.length) {
        toggleExpander(buttonLabel[0]);
      }

      if ($(window).width() < getBreakpoints().lg) {
        return;
      }

      const curExcerptHeight = curExcerpt.height();
      const curExcerptInner = curExpander.find('.c-expander__excerpt-inner');
      let curExcerptInnerHeight = curExcerptInner.prop('scrollHeight');
      const additionalHeight = getAdditionalHeight(container);

      if (offerInner.length) {
        curExcerptInnerHeight = offerInner.prop('scrollHeight');
      }

      if (curExcerptInnerHeight > curExcerptHeight) {
        curButton.show();
        curShadow.show();
      } else {
        hideExpander(curExpander);
      }

      if (curExcerptInnerHeight > pictureHeight) {
        curButton.show();
        curShadow.show();
        curExcerpt.height(additionalHeight);
      } else {
        hideExpander(curExpander);
      }
    });
  }

  $(window).on('load resize', () => {
    showButton();
    refreshTabindex();
  });
  $(document).on('click', '.c-expander__button-label', (event) => {
    toggleExpander(event.target);
  });
}(jQuery));  // eslint-disable-line
